
/* REDUX */
import { createStore, combineReducers, applyMiddleware } from "redux";

import thunk from "redux-thunk";

import { composeWithDevTools } from "redux-devtools-extension";

/* IMPORTING REDUCERS */
import {
  counter
} from "./reducers/testReducer";

/* COMBINED REDUCER */
const reducer = combineReducers({
    count: counter,
});



/* INITIAL STATE */
const initialState = {
    count : 0,
};

const middleware = [thunk];

/* REDUX STORE */
const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;